export default __webpack_public_path__ + "static/media/gitter.c6f9ea8e.svg";